import React, { useState, useRef, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import DialogsContainerDialog from "../DialogsContainer"
import { Typography, Box, Button, Switch, IconButton } from "@material-ui/core/"
import { closeAddNewFieldDialog } from "actions/add-new-field-dialog"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import ReusableFormControl from "components/ReusableFormControl"
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded"
import {
  createAdditionalField,
  deleteAdditionalField,
  updateAdditionalField
} from "actions/organization"
import { openSnackBar } from "actions/snack-bar"
import TrashIcon from "@material-ui/icons/Delete"
import LoaderButton from "components/LoaderButton"
const AddNewFieldDialog = ({ fullScreen, classes }) => {
  const dispatch = useDispatch()
  const { open, org, field } = useSelector(state => ({
    open: state.addNewFieldDialog.open,
    org: state.organization.currentOrg,
    field: state.addNewFieldDialog.field
  }))
  const formRef = useRef()
  const [working, setWorking] = useState(false)
  const [switchValue, setSwitchValue] = useState(true)
  const [fieldOptions, setFieldOptions] = useState([])

  const handleChange = () => {
    setSwitchValue(!switchValue)
  }

  const handleClose = () => {
    setSwitchValue(true)
    setFieldOptions([])
    setWorking(false)
    dispatch(closeAddNewFieldDialog())
  }
  const handleSave = values => {
    setWorking(true)
    let options = fieldOptions
    if (options && options.length === 0) {
      options = null
    }
    if (field) {
      dispatch(updateAdditionalField({ ...values, options }, field.id))
        .then(handleClose)
        .catch(err => {
          console.log(err)
          dispatch(openSnackBar({ message: err.message }))
          setWorking(false)
        })
    } else {
      dispatch(createAdditionalField({ ...values, options }, org.id))
        .then(handleClose)
        .catch(err => {
          console.log(err)
          dispatch(openSnackBar({ message: err.message }))
          setWorking(false)
        })
    }
  }

  const handleRemoveOption = id => {
    dispatch(deleteAdditionalField(id))
      .then(res => {
        dispatch(closeAddNewFieldDialog())
      })
      .catch(err => {
        dispatch(openSnackBar({ message: err.message }))
        dispatch(closeAddNewFieldDialog())
      })
  }

  const AddNewFieldSchema = Yup.object().shape({
    name: Yup.string().required("Required")
  })

  const handleCancel = i => {
    setFieldOptions(fieldOptions.filter((e, ii) => ii !== i))
  }

  useEffect(() => {
    if (field) {
      setFieldOptions(field.options && field.options.split(","))

      setSwitchValue(false)
    }
    if (field && field.options === null) {
      setSwitchValue(true)
    }
  }, [field])

  return (
    <DialogsContainerDialog
      fullScreen={fullScreen}
      open={open}
      handleClose={handleClose}
      title="Additional Field"
      subtitle="Create a custom field for your users to fill out when creating a profile"
      content={
        <Formik
          initialValues={{
            name: field ? field.name : "",
            option: ""
          }}
          validationSchema={AddNewFieldSchema}
          onSubmit={handleSave}
          innerRef={formRef}
        >
          {formikProps => (
            <Form ref={formRef}>
              <Box className={classes.addNewFieldContainer}>
                <Box
                  display="flex"
                  // flexWrap="nowrap"
                  className={classes.fieldNameContainer}
                >
                  <Box className={classes.leftFieldNameContainer}>
                    <ReusableFormControl
                      name="name"
                      label="Field name"
                      formikProps={formikProps}
                      inputLabelClass={classes.labelTextColor}
                    />
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    className={classes.rigthFieldNameContainer}
                  >
                    <Switch
                      color="primary"
                      checked={switchValue}
                      onChange={handleChange}
                    />

                    <Box
                      className={
                        switchValue === false ? classes.freeTextDisabled : null
                      }
                    >
                      <Typography
                        variant="h5"
                        className={classes.freeTextTitle}
                      >
                        Free text
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className={classes.allowUserText}
                      >
                        Allow user to write answer
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box
                  className={
                    switchValue
                      ? classes.createUserResponseContainerDisabled
                      : classes.createUserResponseContainer
                  }
                >
                  <Box display="flex" justifyContent="center">
                    <Typography
                      variant="h5"
                      className={classes.createUserTitle}
                    >
                      Create user responses
                    </Typography>
                  </Box>

                  <Box className={classes.fieldOptionContainer} display="flex">
                    <ReusableFormControl
                      id="option"
                      name="option"
                      label="Field Option"
                      formikProps={formikProps}
                      inputLabelClass={classes.labelTextColor}
                      inputProps={{
                        disabled: switchValue
                        // onKeyDown: key => {
                        //   console.log(key)
                        // }
                      }}
                    />

                    <Button
                      className={classes.addButton}
                      onClick={() => {
                        const option = formikProps.values.option
                        if (option) {
                          const optionsArray = fieldOptions
                            ? [...fieldOptions, option]
                            : [option]
                          setFieldOptions(optionsArray)
                          formikProps.setFieldValue("option", "")
                        }
                        document.getElementById("option").focus()
                      }}
                      disabled={switchValue}
                    >
                      <AddCircleRoundedIcon color="secondary" />
                    </Button>
                  </Box>
                </Box>

                <Box>
                  {fieldOptions &&
                    fieldOptions.map((option, i) => (
                      <Box
                        className={classes.fieldOptionChildContainer}
                        key={i}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography
                          variant="subtitle2"
                          className={classes.grayText}
                        >
                          {option}
                        </Typography>
                        <IconButton
                          disabled={switchValue}
                          color="secondary"
                          onClick={() => handleCancel(i)}
                        >
                          <TrashIcon />
                        </IconButton>
                      </Box>
                    ))}
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      }
      buttons={
        <Box
          display="flex"
          justifyContent="flex-end"
          className={classes.buttonsContainer}
        >
          <Box flexGrow={1}>
            <Button
              className={classes.removeButton}
              variant="text"
              onClick={() => handleRemoveOption(field.id)}
            >
              remove field
            </Button>
          </Box>
          <Button
            onClick={handleClose}
            variant="text"
            className={classes.cancelButton}
          >
            Cancel
          </Button>
          <LoaderButton
            working={working}
            color="primary"
            classes={{ button: classes.saveButton }}
            onClick={e => {
              formRef.current.handleSubmit()
            }}
          >
            Save
          </LoaderButton>
        </Box>
      }
    />
  )
}

export default withStyles(styles)(AddNewFieldDialog)



// WEBPACK FOOTER //
// ./src/dialogs/AdditionalField/index.jsx